module.exports = __webpack_public_path__ + "img/aqfh-img-85.d5869af6.png";